import React, { useState, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import * as routerSelectors from 'app/selectors/router';
import FailureState from 'app/components/customer/dashboard/FailureState';
import { AvailableProducts } from 'app/constants/Products';
import Step0 from './Step0';
import Step1 from './Step1';
import NameStep from '../Parts/Step3';
import DrawerMenu from 'app/components/common/DrawerMenu';
import { Drawer, NavBar, PageWrapper } from 'mui';
import LoginType from 'app/components/customer/Registration/Parts/LoginType';

const mapStateToProps = (state) => {
  const router = routerSelectors.selectRouterQuery(state);
  const feedbackParam = router.get('registration_feedback');
  const testMode = router.get('test_mode');
  const bep = router.get('bep');
  const aep = router.get('aep');
  const wep = router.get('wep');

  return {
    feedbackParam,
    initialValues: {
      settings: {
        product: AvailableProducts.Lover,
        test_mode: testMode,
        bep,
        aep,
        wep,
      },
      step0: {},
      step1: {
        state: '',
        pc_opt_in: false,
        mso_opt_in: false,
        over_18: false,
      },
      step2: {
        first_name: '',
        last_name: '',
      },
      step3: {
        email: window.emailFromTypeform,
        password: '',
        password_confirmation: '',
      },
    },
  };
};

const LoverRegistration = ({ feedbackParam, initialValues, experimentVariant }) => {
  // eslint-disable-next-line @typescript-eslint/ban-types
  const [allValues, setAllValues] = useState(initialValues);
  const [currentStep, setCurrentStep] = useState(0);
  const stepValue = allValues[`step${currentStep}`];

  const onSubmitNextStep = useCallback(
    (values) => {
      setAllValues((allValues) => ({
        ...allValues,
        [`step${currentStep}`]: values,
      }));
      setCurrentStep(currentStep + 1);
    },
    [currentStep],
  );

  const content = useMemo(
    () => (
      <>
        {currentStep === 0 && <Step0 onSubmit={onSubmitNextStep} />}
        {currentStep === 1 && (
          <Step1 initialValues={stepValue} onSubmit={onSubmitNextStep} experimentVariant={experimentVariant} />
        )}
        {currentStep === 2 && <NameStep initialValues={stepValue} onSubmit={onSubmitNextStep} />}
        {currentStep === 3 && <LoginType allValues={allValues} />}
      </>
    ),
    [currentStep, stepValue, onSubmitNextStep, experimentVariant],
  );

  if (feedbackParam) {
    return (
      <Drawer sideContent={<DrawerMenu loggedIn={false} />}>
        <NavBar />
        <FailureState state={feedbackParam} />
      </Drawer>
    );
  }

  return <PageWrapper>{content}</PageWrapper>;
};

export default connect(mapStateToProps)(LoverRegistration);
